/**
 * Web Style Import
 *
 */

import './style/dnb-hr.scss'
